import React, { createContext, useEffect, useState } from 'react'
import { any } from 'prop-types'
import Auth from '../services/http/Auth'
const PermissionsContext = createContext()

// Classifica a falha em uma causa amigável ao usuário. O motivo técnico
// (mensagem de exceção do backend, etc) nunca deve ser exibido na tela —
// só serve para o console/diagnóstico do desenvolvedor.
const classifyFailureReason = status => {
  if (status === 401 || status === 403) return 'unauthorized'
  if (status === 404) return 'not_found'
  if (!status) return 'network'
  return 'server'
}

const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState({ permissions: [], roles: [] })
  const [token, setToken] = useState('')
  const [permissionsError, setPermissionsError] = useState(null)

  const getPermissions = async () => {
    if (permissions?.permissions.length > 0) return

    try {
      const resp = await Auth().store({})
      const status = resp?.status
      const data = resp?.data
      const isSuccess =
        status >= 200 &&
        status < 300 &&
        data &&
        typeof data === 'object' &&
        !data.error

      if (!isSuccess) {
        const technicalDetail =
          (typeof data === 'object' && (data?.error || data?.message)) || data
        // eslint-disable-next-line no-console
        console.error('[permissions] Falha ao carregar permissões:', {
          status,
          detail: technicalDetail
        })
        setPermissionsError({
          status: status || 0,
          reason: classifyFailureReason(status)
        })
        return
      }

      setPermissions(data)
      setPermissionsError(null)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[permissions] Erro de rede ao carregar permissões:', err)
      const status = err?.response?.status
      setPermissionsError({
        status: status || 0,
        reason: classifyFailureReason(status)
      })
    }
  }
  useEffect(() => {
    if (token !== '' && token !== undefined && token !== null) {
      getPermissions()
    }
  }, [token])

  const hasThisPermission = ({ permission = '', roles = '' }) => {
    const [resource, scope] = permission.split('#')
    let result = false
    if (permissions !== null) {
      if (permission !== '') {
        if (resource && scope) {
          result = permissions.permissions[resource]?.includes(scope)
        } else {
          result = permissions.roles?.includes(roles)
        }
      } else {
        result = permissions.roles?.includes(roles)
      }
    }
    return result
  }

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        token,
        setToken,
        hasThisPermission,
        permissionsError,
        retryPermissions: getPermissions
      }}
    >
      {children}
    </PermissionsContext.Provider>
  )
}

PermissionsProvider.propTypes = {
  children: any
}

export { PermissionsProvider, PermissionsContext }
